import GamesLogoIcon from 'ui-component-library/icons/crossfit-games-logo.svg'

import style from './style.scss'

const GAMES_SITE_URL = process.env.GAMES_SITE_URL

type Props = {
  ariaLabel?: string
  className?: string
}

function GamesLogo(props: Props) {
  const { ariaLabel, className } = props

  return (
    <a
      aria-label={ariaLabel}
      className={className}
      href={GAMES_SITE_URL}
      rel='noopener noreferrer'
      target='_blank'
    >
      <GamesLogoIcon className={style.logo} />
    </a>
  )
}

export default GamesLogo
